//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Main parent Component File
//  * @description -   This file renders the html and functionality that renders and manages all child components in the app.
<template>
  <div class="content_bg build_page" :class="{ 'published-survey': all.in_status == constantCommonConfig.SURVEY_PUBLISHED }">
    <div class="row m-0">
      <!-- <h1>{{ surveyData }}</h1> -->
      <!-- <button type="button" @click="logout">log out</button> -->
      <topbar-dashboard v-if="!isFullScreen"></topbar-dashboard>

      <component :key="skipLogicKey" v-if="isSkipLogic === true" v-bind:is="skiplogicComponent"></component>
      <left-dashboard v-else></left-dashboard>

      <!-- <center-dashboard></center-dashboard>
      <right-dashboard></right-dashboard>-->
      <!-- <centerright v-if="isSkipLogic === true"></centerright> -->
      <component v-if="isSkipLogic === false" v-bind:is="centerComponent"></component>
      <component v-if="isSkipLogic === false" v-bind:is="rightComponent"></component>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import topbarDashboard from "./topbar";
import leftDashboard from "./left";
import centerDesign from "./centerdesign";
import rightDesign from "./rightdesign";
import centerSetting from "./centersetting";
import rightSetting from "./rightsetting";
import centerQuestions from "./centerquestions";
import rightQuestions from "./rightquestions";
import skipLogic from "./skipLogic";
var { redirectUrl, constantCommonConfig } = require("../../../config/config.js");

export default {
  name: "App",
  // props: ['surveyData'],
  metaInfo() {
    return {
      title: this.siteTitle
    };
  },
  components: {
    topbarDashboard,
    leftDashboard,
    centerDesign,
    rightDesign,
    centerSetting,
    rightSetting,
    centerQuestions,
    rightQuestions,
    skipLogic

    // surveyMobileSettings,
    // surveyOnlineSettings
  },
  data() {
    return {
      centerComponent: "centerQuestions",
      rightComponent: "rightQuestions",
      skiplogicComponent: "skipLogic",
      tab: null,
      data: [],
      constantCommonConfig: constantCommonConfig,
      siteTitle: ''
    };
  },
  computed: {
    ...mapGetters("LeftSidebarCreate", ["isError", "all", "loading"]),
    ...mapGetters("editquestionEdit", [
      "isSkipLogic",
      "skipLogicKey",
      "isFullScreen"
    ])
  },
  watch: {
    // As always only questions are to be displayed
    // tab: function(val) {
    //   if (val == "designleft") {
    //     this.centerComponent = "centerDesign";
    //     this.rightComponent = "rightDesign";
    //   } else if (val == "settingleft") {
    //     this.centerComponent = "centerSetting";
    //     this.rightComponent = "rightSetting";
    //   }
    // For rendering drag components pass component value in $emit tab value and set that variable directly for rendering.......
    // else {
    //   this.centerComponent = "centerQuestions";
    //   this.rightComponent = "rightQuestions";
    // }
    // },
    // Show progress bar bases on loading watcher
    loading: function(val) {
      if(val)
        this.$Progress.start();
      else
        this.$Progress.finish();
    },
    isError: function(val) {
      if (val) {
        window.location.href =
          redirectUrl + process.env.CAKE_BASE_PATH + "error";
        // this.$router.push({ name: "ErrorPage" });
      }
    }
  },
  async created() {
    // Using the service bus
    EventBus.$on("LeftTabSelected", tab => {
      this.tab = tab;
    });
  },
  beforeMount: async function() {
    this.data = this.$session.getAll();
    this.data["in_survey_Id"] = this.$route.params.id;
    if (this.$route.path.includes("createform") || !this.all.flag)
      await this.getSurveyById(this.data);
    this.siteTitle = (this.$route.path.includes("createform")) ? 'Create Form' : (this.all.in_status == 1 ? 'Form' : 'Draft Form');
    await this.fetchAllSurveyTypes(this.data);
  },
  mounted: async function() {
    // EventBus.$emit('userData', this.surveyData);
    await this.getWhiteLabelDetails()
  },
  methods: {
    ...mapActions("LeftSidebarCreate", ["getSurveyById", "fetchAllSurveyTypes"]),
    async getWhiteLabelDetails() {
      var parts = window.location.href.split('.')
      // parts[0] = 'http://hispec';
      // parts[1] = 'hispecservices';
      // parts[2] = 'com/doyenhub';
      if (parts[0].includes('//')) parts[0] = parts[0].split('//')[1]
      let domain = parts[0]
      let whitelabel = this.$route.params.whitelabel
      let url = process.env.API_PATH + "/getDomainDetails";
      await axios
        .post(
          url,
          {
            st_subdomain: domain,
            st_whitelabel: whitelabel
          },
          {
            headers: { "Content-Type": "application/json" }
          }
        )
        .then(response => {
          if (response.data.flag === 1) {
            var designdata = response.data.data;
            // Updating favicon according to whitelabel details
            if (designdata.favicon_image_url && designdata.favicon_image_url.length > 0) {
              const favicon = document.getElementById("favicon");
              favicon.href = designdata.favicon_image_url;
            }
          } else if (response.data.flag === 4) {
            console.log("invalid account name");
            this.$awn.alert("The page you requested does not exists.");
            var loc = location.host;
            var locArr = loc.split(".");
            loc = location.protocol + "//" + locArr[1] + "." + locArr[2];
            window.location.href = loc;
          } else {
            console.log("invalid url");
            this.$awn.alert("The page you requested does not exists.");
            window.location.href = redirectUrl;
          }
        })
        .catch();
    }
  }
};
</script>
<!-- <style lang="scss">
@import '../../assets/scss/style'
</style> -->



// WEBPACK FOOTER //
// src/components/Dashboard/Main.vue